import { Skeleton } from "antd";

export const LandingSkeleton = ({ isDarkMode }) => {
  return (
    <div className={`${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* Hero Skeleton - Exact Match */}
      <div className={`border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
        <div className="container px-4 py-8 mx-auto max-w-7xl">
          <div className="flex flex-col items-center justify-between gap-6 lg:flex-row">
            {/* Left Content */}
            <div className="flex-1 text-center lg:text-left">
              {/* Badge */}
              <div className="mb-2">
                <Skeleton.Button active size="small" className="w-24" />
              </div>
              
              {/* Title */}
              <div className="mb-2">
                <Skeleton.Input active size="large" className="w-96" />
              </div>
              
              {/* Subtitle */}
              <div className="mb-3">
                <Skeleton.Input active size="default" className="w-72" />
              </div>
              
              {/* Feature Tags */}
              <div className="flex flex-wrap justify-center gap-2 mb-4 lg:justify-start">
                {[1, 2, 3, 4].map((i) => (
                  <Skeleton.Button key={i} active size="small" className="w-24" />
                ))}
              </div>
              
              {/* Search Modal */}
              <div className="max-w-md mx-auto lg:mx-0">
                <Skeleton.Input active size="large" className="w-80" />
              </div>
              
              {/* Popular Brands Section */}
              <div className="mt-4">
                <div className="mb-2">
                  <Skeleton.Input active size="small" className="w-24" />
                </div>
                <div className="flex flex-wrap justify-center gap-1.5 lg:justify-start">
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <Skeleton.Button key={i} active size="small" className="w-20 h-8" />
                  ))}
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="flex justify-center flex-1">
              <Skeleton.Avatar active size={350} shape="square" className="mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};